<script setup lang="ts">
/**
 * The Logo
 * --------------------------------
 * Jungfrau logo in the top left corner
 * - links to the landing page or opens a confirm dialog to leave the app
 */

const { t: $t } = useNuxtApp().$i18n;
const { openConfirmDialog } = useConfirmActionDialog();
const { isFeatureEnabled } = useFeatureFlags();
const runtimeConfig = useRuntimeConfig();
const route = useRoute();
const { backLink, leaveToBackLink } = useFlowExit();

const isLinked = computed(() => {
    const routeName = getRouteName(route);

    if (routeName
        && (routeName.startsWith('index')
            || routeName.startsWith('esav')
            || routeName.endsWith('start')
        )) {
        return false;
    }
    return true;
});

async function ciao() {
    if (!isLinked.value) {
        return;
    }
    if (backLink.value) {
        leaveToBackLink();
        return;
    }
    if (isFeatureEnabled('landingpage')) {
        await navigateTo('/');
    }
    else {
        openConfirmDialog(
            $t('core.confirmLeaveDialog.heading'),
            $t('core.confirmLeaveDialog.body'),
            async () => {
                await navigateTo(runtimeConfig.public.urlJungfrau, { external: true });
            },
            $t('core.confirmLeaveDialog.confirmLabel'),
            () => {},
            $t('core.confirmLeaveDialog.cancelLabel'),
        );
    }
};
</script>

<template>
    <button
        class="absolute top-5 left-container-gap z-20 print:left-0"
        :class="isLinked ? 'cursor-pointer' : 'cursor-default'"
        @click="ciao"
    >
        <img
            src="~~core/assets/images/jungfrau-logo.svg"
            class="
                w-[43px]
                sm:w-[68px]
                md:w-[80px]
                print:w-[36px]
            "
            alt="Jungfrau - Top of Europe"
            width="80px"
            height="56px"
        >
    </button>
</template>
